//styling
import '../app/App.css';
import 'typeface-lato';

//components
import {Container, Col, Row} from 'react-bootstrap';
import Footer from '../components/footer.js';
import InstagramDisplay from '../components/instagram-embed.js';
import { Link } from 'react-router-dom';
import {HideAt, ShowAt } from 'react-hide-show-utils';

//images
import CenterPiece from '../assets/images/home-page/3BobaCenterPiece.svg';
import CenterPieceLarge from '../assets/images/home-page/DrinkCenterPiece.svg';
import MobileGame from '../assets/images/home-page/MobileGame.png';
import MobileGameLarge from '../assets/images/home-page/MobileGameLarge.png';
import Instructions from '../assets/images/home-page/Instructions.png';
import GooglePlayButton from '../assets/images/home-page/GooglePlayButton.svg';
import GooglePlayButtonLarge from '../assets/images/home-page/GooglePlayButtonLarge.svg';
import AppStoreButton from '../assets/images/home-page/AppStoreButton.svg';
import AppStoreButtonLarge from '../assets/images/home-page/AppStoreButtonLarge.svg';
import TwitterIcon from '../assets/images/home-page/Twit-icon.svg';
import InstaIcon from '../assets/images/home-page/IG-icon.svg';
import FBIcon from '../assets/images/home-page/FB-icon.svg';
import YellowBG from '../assets/images/home-page/YellowWaves.svg';
import Drinks from '../assets/images/home-page/BobafaceDrinks.png';

const Home = () => {
    return (
        <div className="centered" style={{backgroundColor: "#FFFBF3" , height: "100%"}}>
            <HideAt breakpoint="(min-width: 1230px)" >
                <div>
                    <h1 className="title-text"><br />It's a game for boba lovers, made with local flavors!</h1>
                    <img src={CenterPiece} alt="Boba Center Piece"></img>
                    <p className="body-text">
                        We're a boba-themed match-3 game that rewards your play with real drinks from your nearby boba shops.<br />
                        Pick up your drink in-store or through our campus vending machines!
                    </p>
                    <h2 className="subheader-text">Support local businesses, one sip at a time.</h2>
                </div>

                <Container className="centered" 
                    style={{height: '475px', paddingTop: 78, paddingBottom: 78, 
                            backgroundImage: `url(${YellowBG})`, backgroundSize: 'cover', backgroundPosition: 'center'}}>
                <Row>
                    <img src={MobileGame} alt="Play and win boba!" fluid="true"/>
                </Row>
                <Row>
                    <Col>
                        <a href={Link} target="_blank" rel="noopener noreferrer">
                            <img src={AppStoreButton} alt="Download on the App Store" />
                        </a>
                    </Col>
                    <Col>
                        <a href={Link} target="_blank" rel="noopener noreferrer">
                            <img src={GooglePlayButton} alt="Download on the Google Play Store" />
                        </a>
                    </Col>
                </Row>
                </Container>

                <div className="body-section">
                    <h1 className="header-text">Follow us on Instagram!</h1>
                    <InstagramDisplay />
                    <h1 className="header-text">Share</h1>
                </div>

                <Container fluid="true" className="d-flex align-items-center justify-content-center" style={{ minHeight: '5vh' }}>
                <Row className="w-400">
                    <Col>
                    <a href="https://www.x.com/thebobaface/" target="_blank" rel="noopener noreferrer">
                        <img src={TwitterIcon} alt="Follow us on Twitter" />
                    </a>
                    </Col>
                    <Col>
                    <a href="https://www.instagram.com/thebobaface/" target="_blank" rel="noopener noreferrer">
                        <img src={InstaIcon} alt="Follow us on Instagram" />
                    </a>
                    </Col>
                    <Col>
                    <a href="https://www.facebook.com/thebobaface/" target="_blank" rel="noopener noreferrer">
                        <img src={FBIcon} alt="Follow us on Facebook" />
                    </a>
                    </Col>
                </Row>
                </Container>

            </HideAt>

            <ShowAt breakpoint="(min-width: 1230px)">
                <p><br/></p>
                <Container style={{width: "85%"}}>
                    <Row style={{paddingBottom: "165px", paddingTop: "65px"}}>
                        <Col>
                            <Row>
                                <h1 className="title-text" style={{textAlign: "left", maxWidth: "601px"}}>
                                    <span style={{color: "black"}}>
                                    It's a game for boba lovers, made with
                                    </span>
                                    <span style={{color: "#FB7F25"}}>
                                    <br/> local flavors!
                                    </span>
                                </h1>
                            </Row>
                            <Row style={{paddingTop: "35px"}}>
                                <Col>
                                    <a href={Link} target="_blank" rel="noopener noreferrer">
                                        <img src={AppStoreButtonLarge} alt="Download on the App Store" />
                                    </a>
                                    {/* <button disable={true}>
                                        <img src={AppStoreButtonLarge} alt="Download on the App Store" />
                                    </button> */}
                                </Col>
                                <Col>
                                    <a href={Link} target="_blank" rel="noopener noreferrer">
                                        <img src={GooglePlayButtonLarge} alt="Download on Google Play" />
                                    </a>
                                    {/* <button disable={true}>
                                        <img src={GooglePlayButtonLarge} alt="Download on Google Play" />
                                    </button> */}
                                </Col>
                            </Row>
                        </Col>
                        <Col>
                            <img src={CenterPieceLarge} alt="3 Drinks"/>
                        </Col>
                    </Row>

                    <Row style={{paddingBottom: "88px"}}>
                        <Col>
                            <img src={MobileGameLarge} alt="Mobile Game" style={{position: "relative", right: "7%"}}/>
                        </Col>
                        <Col>
                            <Row>
                                <p className='body-text' style={{textAlign: "left"}}>
                                    We're a boba-themed match-3 game
                                    that rewards your play with real drinks
                                    from your nearby boba shops.
                                    <br/><br/>
                                    Pick up your drink in-store or through
                                    our campus vending machines!
                                </p>
                            </Row>
                            <Row>
                                {/* <Container style={{backgroundColor: "#FEECC4", 
                                            borderRadius: 30, padding: 20}}>
                                    <img src={GameSteps} alt='Play, Order, Win!'/>
                                </Container> */}
                                <img src={Instructions} alt='Play, Order, Win!'/>
                            </Row>
                        </Col>
                    </Row>
                    
                    <Row>
                        <h2 className="header-text" style={{fontSize: "33px", textAlign: "left"}}>
                            Follow us on instagram!
                        </h2>
                        <InstagramDisplay />
                    </Row>
                    <Row style={{paddingBottom: "114px"}}>
                        {/*Instagram posts */}
                    </Row>
                    <Row className= "centered">
                        <img src={Drinks} alt="Bobaface Drinks" style={{width: "50%"}}/>
                    </Row>
                </Container>
            </ShowAt>

            {<Footer />}
        </div>
    )
}

export default Home;